import { getResourcePath, getCdnUrl } from "owa-config";
import "./defaultTrustedTypesPolicy";

let owaTrustedTypesPolicy: Pick<TrustedTypePolicy, "createScriptURL"> | undefined;
// Regex to match either /mail/sw.js or /mail/<any string>/sw.js or /mail/<any string>/<any string>/sw.js
const regex: RegExp = /^\/mail\/([^\/]+\/)*sw\.js/;
// Regex to match either /<any string>/<any string>/sw_webpush.js or /sw_<any string>_webpush.js?branch=<any string>
// Includes OWA mini `{prefix}/sw_mini_webpush.js` as defined by router in Microsoft.Owa.Web.Server/Startup.cs
const webpushRegex: RegExp = /^\/([^\/]+\/)*sw(_[^\/_]+)*_webpush\.js(\?(branch|ring|version)=[^\/_=]+){0,1}$/;
// Regex to match AST CDN URLs: https:{cdnUrl}assets/ast/{version}/ast.js
const astCdnRegex: RegExp = /^https:\/\/[^\/]+\/assets\/ast\/[^\/]+\/ast\.js$/;

const isValidUrl = (url: string): boolean => {
    if (url === `${getResourcePath()}mos-proxy.js` ||
        url === "https://content.lifecycle.office.net/dime/v1/dime.js") {
        return true;
    }
    // Check for AST CDN URL pattern: https:{getCdnUrl()}assets/ast/{version}/ast.js
    if (astCdnRegex.test(url) && url.startsWith(`https:${getCdnUrl()}`)) {
        return true;
    }
    return false;
};

if (window.trustedTypes) {
    owaTrustedTypesPolicy = window.trustedTypes.createPolicy("owaTrustedTypesPolicy", {
        createScriptURL: (url: string): string => {
            if (isValidUrl(url) || regex.test(url) || webpushRegex.test(url)) {
                return url;
            }
            
            // The URL is not meeting the conditions for a safe URL so return empty string
            return "";
        },
    });
}

export { owaTrustedTypesPolicy, regex, webpushRegex };
